(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-results"]) return;
  try {
    
const elMore = document.querySelector('.search-products__more button');
const elMain = document.querySelector('.search-products__grid');
elMore.addEventListener('click', function(){
  const blogUrl	= '/search?page=' + elMore.dataset.page + '&q='+elMore.dataset.q+'&type=product';
  elMore.disabled = true;
  fetch(blogUrl).then(function (data){
    return data.text();
  })
  .then(function (html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    const grabbed = div.querySelector('.search-products__grid').innerHTML;
    const isMore = div.querySelector('.search-products__more button');
    elMain.innerHTML = elMain.innerHTML + grabbed;
    if(isMore){
      elMore.setAttribute('data-page', isMore.dataset.page);
      console.log(isMore.dataset.nexturl);
      elMore.disabled = false;
    }
    else elMore.remove();
  });
});

  } catch(e) { console.error(e); }
})();
})();
